import DataService from "../../../services/client/classes/dataService";
import { ISetFavoritesOutput } from "../models/interfaces/dashboard/iSetFavoritesOutput";
import { ISearchMembersInCompanyOutput } from '../models/interfaces/companyProfile/iSearchMembersInCompanyOutput';
import { INonprofitBasedOnFilterOutput } from '../models/interfaces/dashboard/iNonprofitBasedOnFilterOutput';
import { IAddEditLocationsOutput } from '../models/interfaces/iAddEditLocationOutput';

class DashboardService extends DataService {
    constructor() {
    super('/private/database/dashboard/');
    }

  getDashboardData(): JQuery.jqXHR<any> {

    return this.get('dashboardData/', { });
    }

    setFavorites(data: ISetFavoritesOutput): JQuery.jqXHR<any> {
        return this.post('setFavorites/', data)
    }

    setNonprofitNotInteresting(data: ISetFavoritesOutput): JQuery.jqXHR<any> {
        return this.post('setNonprofitNotInteresting/', data)
    }

    getNonprofitsBasedOnFilter(data: INonprofitBasedOnFilterOutput): JQuery.jqXHR<any> {
      return this.get('getNonprofitsBasedOnFilter/', data)
    }

    hideWelcomeCard(): JQuery.jqXHR<any> {
      return this.post('hideWelcomeCard/');
    }

    setMemberLocations(data: IAddEditLocationsOutput): JQuery.jqXHR<any> {
      return this.post('setMemberLocations/', data);
    }

    setMemberCurrentLocation(key: string): JQuery.jqXHR<any>  {
      return this.post('setMemberCurrentLocation/', { key });
    }

    completeTask(type: string): JQuery.jqXHR<any> {
      return this.post('completeTask/', { type });
    }
    
    getCountShortlistOnOpportunity(key: string): JQuery.jqXHR<any> {
      return this.post('getCountShortlistOnOpportunity/', { key });
    }
}

export default new DashboardService();


// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/dashboardService.ts